// This returns how many of a foodItem the user already has in their cart.  The
// items in the cart are matched the same way the marketplace matches them, by
// the item, the individual description and the farm it comes from.
export default function BasketItemQuantity(basketItems, foodItem) {
  // A user that isn't signed in has no cart, and a signed in user may not have
  // added anything to theirs yet.
  if (!basketItems || basketItems.length === 0) {
    return 0;
  }

  const basketItemIndex = basketItems.findIndex((basketItem) => {
    return (
      basketItem.item === foodItem.item &&
      basketItem.individualDescription === foodItem.individualDescription &&
      basketItem.farmName === foodItem.farmName
    );
  });

  // If the item isn't in the cart then the user has none of it.
  if (basketItemIndex === -1) {
    return 0;
  }

  return basketItems[basketItemIndex].quantity;
}
